<template>
    <homework>
        <template #homework-content>
            <div v-if="isLoading"></div>
            <div v-else>
                <div v-if="getHomeworkList.length">
                    <homework-list v-for="homework, index in getHomeworkList" 
                        :key="homework.id"
                        :homework="homework"
                        :index="index+1"
                        :number-of-homework="getHomeworkList.length"
                        :is-open="accordionIsOpen(homework.id)"
                        >
                    </homework-list>
                </div>
                <div v-else>
                    <p class="p-homework-no-data">宿題はありません。自由に学習を進めましょう！</p>
                </div>
            </div>
        </template>
    </homework>
</template>
<script setup lang="ts">
  import {ref, computed, onMounted} from "vue";
  import {useRoute} from "vue-router";
  import {HOMEWORK_PROGRESS} from "@/consts/homework";
  import { useHomeworkStore } from '@/store/student/homework_store';

  const route = useRoute()
  const homeworkStore = useHomeworkStore()

  // this flag is used for show initial dispaly until fetch currentHomework 
  const isLoading = ref(true)
    
  const getHomeworkList = computed(() => {
    if(homeworkStore.isHomeworkCompleted){
      return homeworkStore.currentHomeworks.filter(homework => homework.homework_status === HOMEWORK_PROGRESS.NOTSTARTED || homework.homework_status == HOMEWORK_PROGRESS.INPROGRESS)
      .sort(function(a,b) {return new Date(a.end_datetime).getTime() - new Date(b.end_datetime).getTime()})
    }
    return homeworkStore.currentHomeworks.sort(function(a,b) {return new Date(a.end_datetime).getTime() - new Date(b.end_datetime).getTime()})
  })
    
  onMounted(async() => {
    // Remove the class that prohibits outside (body) scrolling when returning from S3-7, 8, 9 screens with inside scrolling
    let body_tag = document.getElementsByTagName('body')[0]
    body_tag.classList.remove("unscrollable")
    // set screenCode here for show help, it set here because of dynamic component render for route /studet/ can't set dynamic screenCode 
    route.meta.screenCode = 'S9-1'
    homeworkStore.saveIsHomeworkCurrent(true)
    await homeworkStore.fetchCurrentHomework()
    isLoading.value = false
  })
  function accordionIsOpen(hw_id: number){
    // fetch the homework_id is open or not
    let isOpen = homeworkStore.homeworkAccordion[hw_id]
    // check hw_id is in last session or not
    if(isOpen !== undefined){
      return isOpen
    }
    return false
  }
</script>